import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgAansluitenStadsverwarming = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="M10.5 15.06 17 20v10H4V20zM36 30V14h-1l-1-5.02h-2L31 14h-2l-4-4v4h-1l-3.97-4v4H19l-.01 16z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m12.767 15.585-5.86 4.56-.614-.79 5.86-4.56z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="m6 28 4.5-4.5L15 28"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M29 32H10v3h19z"
    />
    <path
      fill="#60D15D"
      d="M31 28h-3v7h3zM12 27H9v8h3z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgAansluitenStadsverwarming);

export default ForwardRef;
